module.exports = __webpack_public_path__ + "img/triangle2red.eb3ba0a4.png";